import countryList from 'react-select-country-list';
import { MultiValue } from 'react-select';
import { Option } from '@utils/react-select.ts';

export enum BrandType {
  Visa = 'visa',
  MasterCard = 'mastercard',
  AmericanExpress = 'amex',
  Discover = 'discover',
  DinersClub = 'diners',
}

export enum AudioFileSectionBackEnum {
  CLIENT_BIO = 'biography',
  ECONOMIC_DAMAGES = 'damage',
  INCIDENT_FACTS = 'fact',
  NEGLIGENCE = 'liability',
  MEDICAL_TREATMENT = 'medical_treatment',
  NON_ECONOMIC_DAMAGES = 'non_economic_damage',
  PAST_BILLS = 'past_bills',
  FUTURE_BILLS = 'future_bills',
  LOSS_OF_INCOME = 'loss_of_income',
}

export const incidentTypesList = [
  'Motor Vehicle Collision',
  'Premises Liability',
  'Trucking (18 wheeler or commercial vehicle)',
  'Dog Bite',
  'Slip and Fall',
  'Medical Malpractice',
];

export const incidentTypesOptions: MultiValue<Option> = [
  { value: 'Motor Vehicle Collision', label: 'Motor Vehicle Collision' },
  { value: 'Premises Liability', label: 'Premises Liability' },
  {
    value: 'Trucking (18 wheeler or commercial vehicle)',
    label: 'Trucking (18 wheeler or commercial vehicle)',
  },
  { value: 'Dog Bite', label: 'Dog Bite' },
  { value: 'Slip and Fall', label: 'Slip and Fall' },
  { value: 'Medical Malpractice', label: 'Medical Malpractice' },
];

// Incident types added after demand letter templates were set up. Templates
// saved before then have no example files for these, so uploading examples
// for them is optional; generation falls back to the template's other
// examples when a type has none.
export const incidentTypesWithOptionalExamples: string[] = [
  'Medical Malpractice',
];

export const CANCEL_SUBSCRIPTION_MODAL_TITLE = 'Cancel subscription';
export const CANCEL_SUBSCRIPTION_MODAL_TEXT =
  'Are you sure you want to cancel your subscription? You will ' +
  'still enjoy full access to all features of your plan until the ' +
  'end of the current billing cycle.';
export const SUBMIT_SUBSCRIPTION_MODAL_TITLE = 'Submit subscription';
export const SUBMIT_SUBSCRIPTION_MODAL_TEXT =
  'Are you sure you want to submit subscription?';
export const START_TRIAL_MODAL_TITLE = 'Start trial';
export const START_TRIAL_MODAL_TEXT = 'Are you sure you want to start trial?';

export const ERROR_MESSAGE =
  'An error occurred. There was an issue processing your request. Please try again or change your request. ';
export const FILE_SIZE_LIMIT = 500 * 1024 * 1024; // 500MB
export const AUDIO_SIZE_LIMIT = 100 * 1024 * 1024;
export const IMAGE_SIZE_LIMIT = 10 * 1024 * 1024; // 10MB

export const SECTION_IMAGE_SIZE_LIMIT = 10 * 1024 * 1024;
export const FILE_UPLOAD_TIMEOUT = 45 * 60 * 1000; // 45 minutes for large file uploads

export const ALLOWED_IMAGE_EXTENSIONS = ['jpg', 'jpeg', 'png'];
export const ALLOWED_FILE_EXTENSIONS = ['doc', 'docx', 'pdf'];
export const ALLOWED_AUDIO_EXTENSIONS = ['wav', 'mp3', 'ogg'];
export const ALLOWED_AUDIO_TEXT_EXTENSIONS = [
  'wav',
  'mp3',
  'ogg',
  'doc',
  'docx',
  'pdf',
];

export const DROPZONE_ALLOWED_FILE_TYPES = {
  'audio/*': ['.mp3', '.wav', '.ogg'],
  'image/*': ['.png', '.jpg', '.jpeg'],
};

export const CREATION_FILE_TITLE = 'Create by uploading files';
export const CREATION_FILE_TEXT =
  "You'll upload documents using the input form, and our AI will process it to generate the document";
export const CREATION_FORM_TITLE = 'Create by filling form';
export const CREATION_FORM_TEXT =
  "You'll input data into the form provided. You'll encounter either light or advanced input fields, each accompanied by an explanation.";
export const CREATION_AUDIO_PROMPT =
  'Add prompts to tell AI about your preference of tone, style, limits or including additional data';
export const CREATION_BASIC_WITH_PARSER_TEXT =
  "You'll enter data into the form provided.  You'll have the opportunity to parse the attachments and use the data to generate the document..";
export const CREATION_BASIC_WITH_PARSER_TITLE =
  'Create by filling form and parsing files';

export const COUNTRY_LIST = countryList().getData();

export const US_STATES_OPTIONS = [
  { value: 'AL', label: 'AL - Alabama' },
  { value: 'AK', label: 'AK - Alaska' },
  { value: 'AZ', label: 'AZ - Arizona' },
  { value: 'AR', label: 'AR - Arkansas' },
  { value: 'CA', label: 'CA - California' },
  { value: 'CO', label: 'CO - Colorado' },
  { value: 'CT', label: 'CT - Connecticut' },
  { value: 'DE', label: 'DE - Delaware' },
  { value: 'DC', label: 'DC - District Of Columbia' },
  { value: 'FL', label: 'FL - Florida' },
  { value: 'GA', label: 'GA - Georgia' },
  { value: 'HI', label: 'HI - Hawaii' },
  { value: 'ID', label: 'ID - Idaho' },
  { value: 'IL', label: 'IL - Illinois' },
  { value: 'IN', label: 'IN - Indiana' },
  { value: 'IA', label: 'IA - Iowa' },
  { value: 'KS', label: 'KS - Kansas' },
  { value: 'KY', label: 'KY - Kentucky' },
  { value: 'LA', label: 'LA - Louisiana' },
  { value: 'ME', label: 'ME - Maine' },
  { value: 'MD', label: 'MD - Maryland' },
  { value: 'MA', label: 'MA - Massachusetts' },
  { value: 'MI', label: 'MI - Michigan' },
  { value: 'MN', label: 'MN - Minnesota' },
  { value: 'MS', label: 'MS - Mississippi' },
  { value: 'MO', label: 'MO - Missouri' },
  { value: 'MT', label: 'MT - Montana' },
  { value: 'NE', label: 'NE - Nebraska' },
  { value: 'NV', label: 'NV - Nevada' },
  { value: 'NH', label: 'NH - New Hampshire' },
  { value: 'NJ', label: 'NJ - New Jersey' },
  { value: 'NM', label: 'NM - New Mexico' },
  { value: 'NY', label: 'NY - New York' },
  { value: 'NC', label: 'NC - North Carolina' },
  { value: 'ND', label: 'ND - North Dakota' },
  { value: 'OH', label: 'OH - Ohio' },
  { value: 'OK', label: 'OK - Oklahoma' },
  { value: 'OR', label: 'OR - Oregon' },
  { value: 'PA', label: 'PA - Pennsylvania' },
  { value: 'PR', label: 'PR - Puerto Rico' },
  { value: 'RI', label: 'RI - Rhode Island' },
  { value: 'SC', label: 'SC - South Carolina' },
  { value: 'SD', label: 'SD - South Dakota' },
  { value: 'TN', label: 'TN - Tennessee' },
  { value: 'TX', label: 'TX - Texas' },
  { value: 'UT', label: 'UT - Utah' },
  { value: 'VT', label: 'VT - Vermont' },
  { value: 'VI', label: 'VI - Virgin Islands' },
  { value: 'VA', label: 'VA - Virginia' },
  { value: 'WA', label: 'WA - Washington' },
  { value: 'WV', label: 'WV - West Virginia' },
  { value: 'WI', label: 'WI - Wisconsin' },
  { value: 'WY', label: 'WY - Wyoming' },
];
